import React from "react";
import PageMeta from "~/components/common/meta";
import { BillingSubNav } from "~/components/admin/billing";
import { QuickBooksIntegration } from "~/components/admin/billing";

export const ScreenQuickBooksIntegration: React.FC = () => {
  return (
    <div>
      <PageMeta
        title="QuickBooks Integration | Art Handler"
        description="Manage QuickBooks integration settings and connections"
      />

      <BillingSubNav activeKey="quickbooks" />

      <QuickBooksIntegration />
    </div>
  );
};

export default ScreenQuickBooksIntegration;
